<template>
  <div class="mediaServer_wrap chinese_container">
    <myHeader />
    <!-- banner模块 -->

    <div class="banner">
      <canvas id="canvasId"></canvas>

      <div class="banner_content">
        <p class="wow fadeInUp ProductTitle" style="margin-bottom: 50px">
          Server 媒体服务器
        </p>
        <p style="font-size: 36px" class="wow fadeInUp TwoProductTitle">
          匹配hecoos软件系统的一款<br />
          功能强大、稳定高效的多媒体服务器
        </p>

        <router-link
          id="cn_media_server_contact_us"
          class="callMe"
          :to="{ name: 'chCaseDemonstration', hash: '#specific-position' }"
          >联系我们</router-link
        >
      </div>
    </div>

    <!-- 产品模块 -->
    <div class="product" id="product_section">
      <div class="tab" id="tab">
        <p style="font-size: 36px; font-weight: 900" class="wow fadeInUp">
          hecoos Server
        </p>
        <p
          style="font-size: 72px; font-weight: 700; margin-top: 12px"
          class="wow fadeInUp ProductTitle"
        >
          包含哪些产品？
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span
            :class="{ select: currentTabIndex === 0 }"
            @click="selectTab(0)"
          >
            Server-D
          </span>
          <span
            :class="{ select: currentTabIndex === 1 }"
            @click="selectTab(1)"
          >
            Server-C
          </span>
          <span
            :class="{ select: currentTabIndex === 2 }"
            @click="selectTab(2)"
          >
            Server-R
          </span>
          <div
            class="underline"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="layout_media"></div>
        <div class="content">
          <!-- server-D部分 -->
          <div class="layout_media">
            <div class="serverContent" v-show="showContents[0]">
              <p
                style="font-size: 24px; margin-bottom: 40px"
                class="wow fadeInUp"
              >
                Server-D
              </p>
              <p
                style="font-size: 72px; margin-bottom: 100px; font-weight: 700"
                class="wow fadeInUp"
              >
                功能强大&nbsp;&nbsp;<span style="color: #2a82e4">稳定高效</span>
              </p>
              <p
                style="
                  font-size: 22px;
                  color: #86868b;
                  line-height: 36px;
                  letter-spacing: 1.2px;
                "
                class="wow fadeInUp"
              >
                hecoos Server –
                D是匹配hecoos软件系统的一款<span>功能强大、稳定高效</span>的多媒体服务器。其硬件设计契合展演现场严苛执行标准，专为快速部署量身定制。它可在传统舞台播控系统的基础之上实现更加复杂的三维输出，并将视频、灯光、机械等多样舞台设备与元素巧妙融合，统一控制播放，还可在虚拟制作流程中里充当LED
                屏扩展输出“利器”。内置的
                hecoos软件系统让预演工程文件与现场执行流畅衔接。 依托
                hecoos工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，<span
                  >从而践行“设计即实现”的产品设计理念，助您打造精彩绝伦的视觉体验。</span
                >
              </p>
              <img
                style="width: 1201px; height: 634px; margin: 80px 0"
                src="https://download.hecoos.com/enlightv/2025-17/9bf5a3c707dd185121045f4da6e76657.png"
                alt=""
                class="wow fadeInUp"
              />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info" class="wow fadeInUp"></clickSwitch>

              <!-- 参数部分 -->
              <p
                style="font-size: 24px; margin: 150px 0 60px"
                class="wow fadeInUp"
              >
                硬件规格
              </p>
              <p
                style="font-size: 72px; font-weight: 700; margin-bottom: 16px"
                class="wow fadeInUp"
              >
                参数细细看
              </p>
              <img
                style="width: 1246px; height: 582px"
                src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png"
                alt=""
                class="wow fadeInUp"
              />
            </div>
            <div class="parameters" v-show="showContents[0]">
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp"
                >
                  规格参数
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    运行电压: 100-240V，50-60Hz，13 amps冗余电源运行功率:800W
                    @110V(正常)、1000W @ 110V(最大)<br />
                    机箱规格:4U 19”英寸机架操作系统:Windows 10 Pro <br />
                    CPU处理器:英特尔 至强 Gold 6226R 处理器(16核32线程)<br />
                    系统内存:64G RDIMM DDR4内存 (32G x 2)<br />
                    单台系统显存要求:16G <br />
                    单台支持贴图像素点:1920*1080*16<br />
                    Artnet:支持 <br />
                    系统硬盘:2TB SSD<br />
                    最大SSD硬盘数量:4<br />
                    支持物理上级联扩展模式，扩展模式不受数量限制支持Optitrack红外追踪系统<br />
                    具备背板照明 <br />
                    具备PCI-E扩展连接器<br />
                    网络接口:1xGB LAN ，10XGB LAN<br />
                    具备OLED状态文本显示(详细描述)<br />
                    机箱宽高深(mm):430(宽)*178(高)*634(深)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp"
                >
                  工作环境容限
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    温度:5-35°C(40°-95°) <br />
                    湿度:5%-95%(non-condensing) <br />
                    海拔高度:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp"
                >
                  I/O规格
                </p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        视频输出<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        视频输入<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2 <br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        数据/外设<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        音视频输入/输出<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp"
                >
                  原厂配件
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    机械键盘鼠标 <br />
                    800W铂金电源 <br />
                    环出线<br />
                    DP转DVI转接线 x6SM <br />
                    DP线 x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 48px; display: inline-block"
                  class="wow fadeInUp"
                >
                  售后保障
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    软件终身免费 <br />
                    使用及升级服务器 <br />
                    硬件两年保修免费 <br />
                    远程技术支持
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-C部分 -->
          <div class="layout_media">
            <div class="serverContent" v-show="showContents[1]">
              <p
                style="font-size: 24px; margin-bottom: 40px"
                class="wow fadeInUp"
              >
                Server-C
              </p>
              <p
                style="font-size: 72px; font-weight: 700; margin-bottom: 100px"
                class="wow fadeInUp"
              >
                虚拟现实&nbsp;&nbsp;<span style="color: #2a82e4">精准契合</span>
              </p>
              <p
                style="
                  font-size: 22px;
                  color: #86868b;
                  line-height: 36px;
                  letter-spacing: 1.2px;
                "
                class="wow fadeInUp"
              >
                一款专为虚拟制作领域设计的多媒体服务器，作为虚拟制作拍摄流程中的<span>“核心枢纽”</span>，
                xR – C
                多媒体服务器可以和追踪系统协作，依据追踪信息（例如演员的位置、摄像机的运动轨迹）迅速调度实时渲染引擎，灵活改变渲染画面的场景视角，确保虚拟和现实<span>元素精准契合</span>。搭配灯光系统时，它能根据场景氛围和光照需求，实时调整虚拟物体的光影效果，从而提升成片的视觉感受。xR
                –
                C以其灵活的扩展性、优异的稳定性与丰富的I/O接口为拍摄现场提供坚实保障，不仅如此，它还可以<span
                  >根据现场实际需求进行专业定制化配置，是您进行虚拟制作工作的必要选择。</span
                >
              </p>
              <img
                style="width: 1201px; height: 634px; margin: 80px 0"
                src="https://download.hecoos.com/enlightv/2025-17/58ba9ed9b9f7b2f7e2a0b221d3438db8.png"
                alt=""
                class="wow fadeInUp"
              />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info" class="wow fadeInUp"></clickSwitch>
              <!-- 参数部分 -->

              <p
                style="font-size: 24px; margin: 150px 0 60px"
                class="wow fadeInUp"
              >
                硬件规格
              </p>
              <p
                style="font-size: 72px; font-weight: 700; margin-bottom: 16px"
                class="wow fadeInUp"
              >
                参数细细看
              </p>
              <img
                style="width: 1246px; height: 582px"
                src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png"
                alt=""
                class="wow fadeInUp"
              />
            </div>
            <div class="parameters" v-show="showContents[1]">
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  规格参数
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    CPU处理器:英特尔 至强 Gold 6226R 处理器(16核32线程)<br />
                    主板:定制主板 <br />
                    系统内存:64G RDIMM DDR4内存 (32G x 2) <br />
                    硬盘1:M.2 NVMe SSD 2TB系统盘 <br />
                    硬盘2:U.2 NVMe SSD数据盘 4TB<br />
                    风扇型号:定制散热风扇 <br />
                    机箱型号:定制机箱 <br />
                    显卡：A5000 24GB GDDR6<br />
                    同步卡：NVIDIA 二代同步卡 <br />
                    采集卡：BMD-8k pro<br />
                    BMC卡:远程网络管理 <br />
                    网卡1：1Gb RJ45 <br />
                    网卡2：Mellanox 迈络思100Gb<br />
                    光口 多屏卡背板：定制多屏卡背板<br />
                    多屏卡主板：定制多屏卡主板DP/DVI
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  工作环境容限
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    温度:5-35°C(40°-95°) <br />
                    湿度:5%-95%(non-condensing) <br />
                    海拔高度:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  I/O规格
                </p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        视频输出<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        视频输入<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2 <br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        数据/外设<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        音视频输入/输出<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <p style="font-size: 32px; display: inline-block">原厂配件</p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    机械键盘鼠标 <br />
                    800W铂金电源 <br />
                    环出线<br />
                    DP转DVI转接线 x6SM <br />
                    DP线 x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  售后保障
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    软件终身免费 <br />
                    使用及升级服务器 <br />
                    硬件两年保修免费 <br />
                    远程技术支持
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- server-R部分 -->
          <div class="layout_media">
            <div class="serverContent" v-show="showContents[2]">
              <p
                style="font-size: 24px; margin-bottom: 40px"
                class="wow fadeInUp"
              >
                Server-R
              </p>
              <p
                style="font-size: 72px; font-weight: 700; margin-bottom: 100px"
                class="wow fadeInUp"
              >
                自由选择&nbsp;&nbsp;<span style="color: #2a82e4">灵活调配</span>
              </p>
              <p
                style="
                  font-size: 22px;
                  color: #86868b;
                  line-height: 36px;
                  letter-spacing: 1.2px;
                "
                class="wow fadeInUp"
              >
                hecoos Server xR –
                R媒体服务器作为<span>强大的引擎载体</span>，将UnrealEngine/Notch/Unity3D等实时渲染引擎所生产的三维虚拟场景融入拍摄流程之中。融入<span>SMPTEST2110标准</span>的100G传输带宽，呈现低延迟、高质量逼真视效。其兼容性出色，不局限于特定引擎，创作者可自由选择多种引擎配合完成同一场景的生产，灵活调配。面对繁重复杂的实时场景渲染任务时，多台xR
                –R渲染节点配合工作，借助集群渲染轻松驾驭超高品质的画面输出，<span>高效处理高负载工作</span>。加之实时光线追踪及引擎反向控制等丰富功能，为虚拟内容创作者提供贴心保障。
              </p>
              <img
                style="width: 1201px; height: 634px; margin: 80px 0"
                src="https://download.hecoos.com/enlightv/2025-17/93682b68b9c7f106bf40939e1059af7a.png"
                alt=""
                class="wow fadeInUp"
              />
              <!-- 亮点模块 -->
              <clickSwitch :Info="Info" class="wow fadeInUp"></clickSwitch>

              <!-- 参数部分 -->

              <p
                style="font-size: 24px; margin: 150px 0 60px"
                class="wow fadeInUp"
              >
                硬件规格
              </p>
              <p
                style="font-size: 72px; font-weight: 700; margin-bottom: 16px"
                class="wow fadeInUp ProductTitle"
              >
                参数细细看
              </p>
              <img
                style="width: 1246px; height: 582px"
                src="https://download.hecoos.com/enlightv/2025-17/6af24860b3995a3bb2d8bad2e1bf0732.png"
                alt=""
                class="wow fadeInUp"
              />
            </div>
            <div class="parameters" v-show="showContents[2]">
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  规格参数
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    CPU处理器:英特尔 酷睿Ultra 9 处理器 285K<br />
                    主板：华硕Z890系列主板 <br />
                    系统内存:64G DDR5内存 <br />
                    硬盘1:M.2 NVMe<br />
                    SSD 2T系统盘 <br />
                    风扇型号:定制散热风扇 <br />
                    机箱型号:通用版机箱<br />
                    系统硬盘:2TB SSD <br />
                    最大SSD硬盘数量:4<br />
                    支持物理上级联扩展模式，扩展模式不受数量限制支持Optitrack红外追踪系统<br />
                    具备背板照明 <br />
                    具备PCI-E扩展连接器 <br />
                    网络接口:1xGB LAN ，10XGB LAN<br />
                    具备OLED状态文本显示(详细描述)<br />
                    机箱宽高深(mm):430(宽)*178(高)*634(深)
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  工作环境容限
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    温度:5-35°C(40°-95°) <br />
                    湿度:5%-95%(non-condensing) <br />
                    海拔高度:0-8850ft(0-2700m)<br />
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  I/O规格
                </p>
                <div class="detailed">
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        视频输出<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        视频输入<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2 <br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                  <div class="test">
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        数据/外设<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                    <div class="detailed_content">
                      <p class="wow fadeInUp">
                        音视频输入/输出<br />
                        <span style="color: #a6a6a6"
                          >6 x DisplayPort 1.2<br />
                          独立输出通道最大分辨率(4096x2160)</span
                        ><br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  原厂配件
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    机械键盘鼠标 <br />
                    800W铂金电源 <br />
                    环出线<br />
                    DP转DVI转接线 x6SM <br />
                    DP线 x4
                  </p>
                </div>
              </div>
              <div class="parameters_content">
                <p
                  style="font-size: 32px; display: inline-block"
                  class="wow fadeInUp"
                >
                  售后保障
                </p>
                <div class="detailed">
                  <p class="wow fadeInUp">
                    软件终身免费 <br />
                    使用及升级服务器 <br />
                    硬件两年保修免费 <br />
                    远程技术支持
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myText :reviews="reviews" v-if="showContents[0]"></myText>
    <myInquire></myInquire>
    <myFooter></myFooter>
    <BackToTop />
  </div>
</template>

<script>
import myHeader from "@/components/pc/myHeader.vue";
import myFooter from "@/components/pc/myFooter.vue";
import test from "@/components/pc/test.vue";
import myText from "@/components/pc/myText.vue";
import myInquire from "@/components/pc/myInquire.vue";
import clickSwitch from "@/components/pc/clickSwitch.vue";
import BackToTop from "@/components/pc/BackToTop";
import { initThreeNoiseEffect } from "@/utils/threeNoiseEffect.js";
import Test from "../../../components/en_pc/test.vue";
export default {
  data() {
    return {
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      tabInfo: {
        server_D: {
          tabName: [
            "内容播放",
            "画面映射",
            "多屏幕延展",
            "3DMapping",
            "灵活扩展I/O",
            "追踪系统接入",
          ],
          imgList: [
            "https://download.hecoos.com/enlightv/2025-17/fae918c5d4a93841bc4769f8c4568c8b.png",
            "https://download.hecoos.com/enlightv/2025-17/a6c324978b81ed0e5dc01b3db014ee17.png",
            "https://download.hecoos.com/enlightv/2025-37/58a8c128d1bacd451c09589dc9273168.png",
            "https://download.hecoos.com/enlightv/2025-17/896f2237bace53a89cbaa2bc7804040a.png",
            "https://download.hecoos.com/enlightv/2025-17/96115941405a2a888c8e3bde5c6ad839.png",
            "https://download.hecoos.com/enlightv/2025-17/d9fac1b1240180c181999e676c3d6d53.png",
          ],
          msgList: [
            "强大的非编渲染引擎，实时高性能2D/3D图形渲染，支持OpenGL、DirectX，支持格式覆盖目前几乎所有视频格式，包括序列帧在内的三十多种视频编码（HAP、HVC等）均可流畅播放。",
            "hecoos可根据创意需求直接将视频画面通过平行投射、球形投射、透视投射、柱形投射等画面映射（Mapping）方式映射到显示介质上，轻松实现3D Mapping及xR背景显示。",
            "无限分辨率的视频与图像解码能力，匹配服务器多级级联系统工作架构，可实现对任意分辨率、任意数量的LED显示屏、投影的点对点流畅播放。",
            "支持 3D 模型导入，可以根据 UV 的展开方式将视频贴合到模型表面，同时可以在三维空间内进行预演和观看。基于三维模型展UV或透视投射原理产生影像内容，通过投影实时反算的方式将内容mapping到真实模型上完成画面输出。",
            "通过接入Arduino套件或直接接入雷达、编码器、控制器等设备，以连接更丰富的输入与输出环境。可直接对接伺服电机、舵机、步进电机等机械设备，为项目实现提供更多可选项。",
            "追踪系统数据接入（VICON、blacktrax、optitrack、stype、Mo-sys、Redspy等）传感器接入（Radar、红外、压感、kinnect等）开源硬件对接（ARDUINO、树莓派等）",
          ],
        },
        server_C: {
          tabName: [
            "镜头测量与定位",
            "延迟校准",
            "色彩校准",
            "多机位切换",
            "引擎关卡/序列管理",
            "虚拟与现实灯光联调控制",
          ],
          imgList: [
            "https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png",
            "https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png",
            "https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png",
            "https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png",
            "https://download.hecoos.com/enlightv/2025-17/23207610ab5776b51566e965a4053b44.png",
            "https://download.hecoos.com/enlightv/2025-17/2f2ac00a4b671a5b47513b91bff11a2b.png",
          ],
          msgList: [
            "5分钟自动计算完成测量得到的镜头数据文件，将三维世界的虚拟摄影机与现场真实摄影机坐标完全对齐无偏差",
            "测量摄影机延迟、媒体延迟，以及手动调整跟踪延迟，可以让屏幕画面和扩展画面完全同步，不出现卡顿和撕裂等画面瑕疵。",
            "通过比较摄影机拍摄LED屏幕和原始输入的色彩，自动计算校色文件，实现屏内画面与扩展画面颜色的准确统一。",
            "当追踪系统数量与摄影机一对一匹配时，导播可根据需要在各追踪机位间无缝、适时切换拍摄画面，以表达丰富多样的视觉语言。",
            "将Server-C服务器的时间线上添加的多个虚拟场景节目与虚幻引擎中的各个场景关卡一一对应，实现随时播控/触发虚拟场景中的序列动画。",
            "以虚拟场景的灯光配置方案来构建真实影棚的灯光布局，hecoos通过ART-NET协议实现真实灯具的直接控制，达到虚拟现实灯光同步联动。",
          ],
        },
        server_R: {
          tabName: ["Rivermax集群渲染", "引擎选择", "引擎反向控制"],
          imgList: [
            "https://download.hecoos.com/enlightv/2025-35/f64b3aac4995550b7bdbd48ce58440b1.png",
            "https://download.hecoos.com/enlightv/2025-17/1e162cde5a14bffd1123ac5213c9fc89.png",
            "https://download.hecoos.com/enlightv/2025-35/157a875b18394fa009714279ac70cd93.png",
          ],
          msgList: [
            "内视锥渲染画面与集群中的其他渲染节点共享，避免各节点的渲染资源浪费，多节点合理分工使画面质量更高、更流畅。使用SMPTE 2110 同步策略对每个渲染节点进行帧锁定，确保虚幻引擎输出与摄影机保持同步。",
            "作为强大的引擎载体，hecoos将Unreal Engine/Notch/Unity 3D/TouchDesigner/Proceesing等实时渲染引擎所生产的视觉内容融入播放与虚拟拍摄流程之中。创作者无需局限于特定引擎，自由选择内容工具完成作品。",
            "虚拟拍摄流程中可通过hecoos反向编辑实时渲染引擎的设置，拍摄现场灵活调整资产细节，使拍摄过程更加顺滑。",
          ],
        },
      },
      Info: "",
      canvasId: {
        type: String,
        required: true,
      },
      reviews: [
        {
          content:
            "在过去的创作中，构思与实际呈现常有偏差，许多想法难以达成。与 hecoos 的配合改变了这个状况，模拟预演的流程使我的团队能够提前预见作品效果，可以及时调整优化。很多种三维映射方案确保最终作品呈现和预期是一致的，不用再因技术局限而妥协作品标准，对于创作团队而言，是非常难得的。",
          author: "邓博",
          position: " 飞扬萝卜  CEO&制作人",
          institution: "",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
    let section = this.$route.query.section;
    if (section) {
      this.scrollToSection();
      this.currentTabIndex = Number(section);
      this.selectTab(this.currentTabIndex);
    }
    initThreeNoiseEffect("canvasId");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  methods: {
    scrollToSection() {
      const element = document.getElementById("product_section");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "start", // 滚动到元素顶部
        });
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.Info = {};
      this.currentTabIndex = index;

      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
      if (index === 1) {
        this.Info = this.tabInfo.server_C;
      } else if (index === 2) {
        this.Info = this.tabInfo.server_R;
      } else {
        this.Info = this.tabInfo.server_D;
      }
      // 将index存储到本地
      // localStorage.setItem("tabIndex", index);
    },
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
  beforeMount() {
    this.Info = this.tabInfo.server_D;
    const n = this.$route.query.section;
    // console.log(n,'123132132132');

    if (n) {
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[n] = true;
    } else {
      this.showContents[0] = true;
    }
  },
  watch: {
    // "$route.query.section": function (newValue) {
    //   // console.log(newValue, 'newValue');
    //   this.showContents = this.showContents.map(() => false);
    //   // 将当前选中的内容显示状态设为 true
    //   this.showContents[newValue] = true;

    //   this.currentTabIndex = Number(newValue); // 更新当前索引
    //   this.updateUnderlinePosition(); // 调用下划线计算方法
    // },
    "$route.query": {
      handler(newValue, oldValue) {
        let section = newValue.section;
        // 处理参数变化的逻辑
        // console.log("参数变化了", newQuery, oldQuery);
        // 可以在这里根据新的参数重新加载数据等
        this.showContents = this.showContents.map(() => false);
        // 将当前选中的内容显示状态设为 true
        this.showContents[section] = true;

        this.currentTabIndex = Number(section); // 更新当前索引
        this.updateUnderlinePosition(); // 调用下划线计算方法
        this.selectTab(this.currentTabIndex);
        // window.location.reload();
      },
      // 深度监听，确保对象内部属性变化也能被捕获
      deep: true,
    },
  },

  components: {
    myHeader,
    myFooter,
    myText,
    myInquire,
    clickSwitch,
    BackToTop,
    Test,
    test,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/xty.scss";
@import "@/styles/optimize_adaptation.scss";
.underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #2a82e4;
  transition: all 0.3s ease;
}

.product {
  overflow: hidden;
}

.callMe {
  display: block;
  text-decoration: none;
  color: #fff;
  width: 151px;
  height: 50px;
  line-height: 50px;
  border-radius: 25px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}
</style>
